import { MyStaffAccountListTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const MyStaffAccountListTrackingSchema: Record<
  MyStaffAccountListTrackingPoint,
  string
> = {
  [MyStaffAccountListTrackingPoint.PageView]: '',
  [MyStaffAccountListTrackingPoint.BackButtonClick]: '',
  [MyStaffAccountListTrackingPoint.StaffAccountButtonClick]: '',
};

export const getMyStaffAccountListPageTypeAndSchema = (
  trackingPoint: MyStaffAccountListTrackingPoint
) => {
  return {
    page_type: PageType.MyStaffAccountListPage,
    schema: MyStaffAccountListTrackingSchema[trackingPoint],
  };
};
